import styled from 'styled-components';

export const FAQStyle = styled.div`
    width: 39%;
    height: 500px;
    margin-left: 220px;

    .header {
        margin-top: 30px;
        border-bottom: 1px solid #d4d4d4;;
    }

    .header h1{
        font-size: 23px;
        font-weight: bolder;
    }
`;